import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import { auth } from "../store/authModule";
import FormLogin from "@/views/FormLogin.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import Plan from "@/views/journals/Plan.vue";
import PlanPackageImportSettings from "@/views/administration/Import/PlanPackageImportSettings/PlanPackageImportSettings.vue";
import PlanContainerImportSettings from "@/views/administration/Import/PlanContainerImportSettings/PlanContainerImportSettings.vue";
import PlanShipmentImportSettings from "@/views/administration/Import/PlanShipmentImportSettings/PlanShipmentImportSettings.vue";
import PlanOrderImportSettings from "@/views/administration/Import/PlanOrderImportSettings/PlanOrderImportSettings.vue";

const routes: Array<RouteRecordRaw> = [
  { path: "/:catchAll(.*)", name: "PageNotFound", component: PageNotFound },
  {
    path: "/",
    name: "Home",
    meta: { layout: "main", auth: true, title: "Главная" },
    component: Home,
  },
  {
    path: "/login",
    name: "login",
    meta: { layout: "auth", auth: false, title: "Вход" },
    component: FormLogin,
  },

  {
    path: "/profile",
    name: "profile",
    meta: { layout: "main", auth: true, title: "Профиль" },
    component: () => import("../views/Profile.vue"),
  },

  //Catalogues
  {
    path: "/gap",
    name: "gap",
    meta: { layout: "main", auth: true, title: "Отступы" },
    component: () => import("../views/catalogues/Gap.vue"),
  },
  {
    path: "/packageVolumeType",
    name: "packageVolumeType",
    meta: { layout: "main", auth: true, title: "Типы пакетов по объему" },
    component: () => import("../views/catalogues/PackageVolumeType.vue"),
  },
  {
    path: "/displacement",
    name: "displacement",
    meta: {
      layout: "main",
      auth: true,
      title: "Допускаемое смещение общего ЦТ груза в транспорте",
    },
    component: () => import("../views/catalogues/Displacement.vue"),
  },
  {
    path: "/container",
    name: "container",
    meta: { layout: "main", auth: true, title: "Контейнеры" },
    component: () => import("../views/catalogues/Container.vue"),
  },
  {
    path: "/dCatalogue",
    name: "dCatalogue",
    meta: { layout: "main", auth: true, title: "Динамические справочники" },
    component: () => import("../views/catalogues/DCatalogue.vue"),
  },
  {
    path: "/feature",
    name: "feature",
    meta: { layout: "main", auth: true, title: "Свойства" },
    component: () => import("../views/catalogues/Feature.vue"),
  },
  {
    path: "/orderComment",
    name: "orderComment",
    meta: { layout: "main", auth: true, title: "Примечания к заказам" },
    component: () => import("../views/catalogues/OrderComment.vue"),
  },

  //Journals
  {
    path: "/plans",
    name: "plans",
    meta: { layout: "main", auth: true, title: "Планы" },
    component: () => import("../views/journals/Plans.vue"),
  },

  {
    path: "/plans/:id",
    name: "plan",
    meta: { layout: "main", auth: true, title: "План" },
    component: Plan,
  },

  //Administration
  {
    path: "/users",
    name: "users",
    meta: { layout: "main", auth: true, title: "Пользователи" },
    component: () => import("../views/administration/Users.vue"),
  },

  {
    path: "/roles",
    name: "roles",
    meta: { layout: "main", auth: true, title: "Роли" },
    component: () => import("../views/administration/Roles.vue"),
  },

  {
    path: "/import",
    name: "import",
    meta: { layout: "main", auth: true, title: "Импорт данных" },
    component: () => import("../views/administration/Import/Import.vue"),
  },
  {
    path: "/logging",
    name: "logging",
    meta: { layout: "main", auth: true, title: "Действия пользователей" },
    component: () => import("../views/administration/Logging.vue"),
  },
  {
    path: "/cleanup",
    name: "cleanup",
    meta: { layout: "main", auth: true, title: "Очистка данных" },
    component: () => import("../views/administration/Cleanup.vue"),
  },

  //Reports
  {
    path: "/loadingReport",
    name: "loadingReport",
    meta: { layout: "main", auth: true, title: "Отчет о погрузке" },
    component: () => import("../views/reports/LoadingReport.vue"),
  },
  {
    path: "/containerReport",
    name: "containerReport",
    meta: { layout: "main", auth: true, title: "Отчет по контейнерам" },
    component: () => import("../views/reports/ContainerReport.vue"),
  },
  {
    path: "/orderReport",
    name: "orderReport",
    meta: { layout: "main", auth: true, title: "Отчет по заказам" },
    component: () => import("../views/reports/OrderReport.vue"),
  },

  //Settings
  {
    path: "/settings",
    name: "settings",
    meta: { layout: "main", auth: true, title: "Настройки" },
    component: () => import("../views/Settings.vue"),
  },
  {
    path: "/planPackageImportSettings/:id",
    name: "planPackageImportSettings",
    meta: { layout: "main", auth: true, title: "Настройки импорта пакетов" },
    component: PlanPackageImportSettings,
  },
  {
    path: "/planContainerImportSettings/:id",
    name: "planContainerImportSettings",
    meta: {
      layout: "main",
      auth: true,
      title: "Настройки импорта контейнеров",
    },
    component: PlanContainerImportSettings,
  },
  {
    path: "/planOrderImportSettings/:id",
    name: "planOrderImportSettings",
    meta: {
      layout: "main",
      auth: true,
      title: "Настройки импорта заказов",
    },
    component: PlanOrderImportSettings,
  },

  {
    path: "/planShipmentImportSettings/:id",
    name: "planShipmentImportSettings",
    meta: {
      layout: "main",
      auth: true,
      title: "Настройки импорта отгрузок",
    },
    component: PlanShipmentImportSettings,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.meta.title) document.title = "Opti Loading";
  else document.title = to.meta.title as string;
  if (to.meta?.auth && to.name !== "login" && !auth.state.user)
    next({ name: "login" });
  else {
    next();
  }
});

export default router;
